import { createSignal, onMount } from "solid-js";
import { useApplication } from "@/context/app";
import {
  Card,
  CardContent,
} from "@/components/shadcn/card";
import { activateAction, deactivateAction, deleteAction } from "../../components/ui/actions/config";
import { ListControl } from "../../components/ui/list/ListControl";
import AdminRow from "./row";
import { ListView } from "../../components/ui/list/ListView";
import { CreateButton } from "../../components/ui/Button";

export default function AdminList() {

  const { setBreadcrumb } = useApplication();

  const actions = [
    activateAction('administrator', 'user'),
    deactivateAction('administrator', 'user'),
    deleteAction('administrator', 'user')
  ];

  const statuses = [{
    text: 'Active',
    value: true
  }, {
    text: 'Inactive',
    value: false
  }];

  const sorts = [{
    "text": 'Created At',
    "value": "created_at"
  }, {
    "text": 'Name',
    "value": "first_name"
  }];

  onMount(async () => {
    setBreadcrumb([
      {
        name: 'Home',
        link: '/home'
      },
      {
        name: 'Administrators',
        current: true
      }
    ]);
  });

  return (
    <>
      <div class="flex">
        <CreateButton href="/administrator/create">New Administrator</CreateButton>
      </div>
      <Card class="w-full">
        <CardContent>
          <ListControl
            mode="list"
            search={''}
            actions={actions}
            filters={[
              {
                type: 'choice',
                label: 'Status',
                name: 'status',
                choices: statuses,
                default: null
              },
              {
                type: 'date',
                label: 'Created At',
                name: 'created_at',
                default: null
              }
            ]}
            sort={{
              column: 'created_at',
              direction: 'asc',
              options: sorts
            }}
            pagination={{
              current: 1, // default 1
              changePerPage: true, // default true
              perPage: 10, // default 10
              options: [10, 20, 50, 100]
            }}
            datasource={{
              type: 'remote',
              config: {
                url: '/administrator/fetch',
                method: 'GET',
                params: {
                  //status: status()
                }
              }
            }}
            contentLoading={false}
          >{(innerProps) => <ListView {...innerProps} template={AdminRow} placeholder={false} />}
          </ListControl>
        </CardContent>
      </Card>
    </>
  );
}
